import { ApplicationRef, ComponentFactoryResolver, inject, Injectable, Injector, Type } from '@angular/core'
import { DOCUMENT } from '@angular/common'
import { ComponentPortal, DomPortalOutlet } from '@angular/cdk/portal'

declare const window: any

@Injectable()
export class DomService {
  protected document = inject(DOCUMENT)

  constructor (
    protected cFR: ComponentFactoryResolver,
    protected appRef: ApplicationRef,
    protected injector: Injector,
  ) {}

  inject (component: Type<any>) {
    new DomPortalOutlet(this.document.body, this.cFR, this.appRef, this.injector).attach(new ComponentPortal(component))
  }
}
